import { useNavigate } from "react-router-dom";
import { Button, H1, Text } from "atoms";
import { Head } from "features/misc";

function NotFound() {
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  return (
    <main>
      <Head title="Not Found" />

      <H1>Sorry!</H1>

      <Text size="lg">We can’t find what you’re looking for... 😥</Text>

      <Button variant="gradient" onClick={goBack}>
        Go Back?
      </Button>
    </main>
  );
}

export { NotFound };
